import Vue from 'vue'

/**
 * 获取指定类型的选项配置
 * @param data
 * @returns {*}
 */
export function getOptionListByField(data) {
  return Vue.axios({
    url: '/api/options/list_by_field',
    method: 'get',
    params: {...data}
  })
}

/**
 * 类型（字段）集合
 *
 * @returns {*}
 */
export function getFieldMap() {
  return Vue.axios({
    url: '/api/options/field_map',
    method: 'get',
    params: {}
  })
}

export function getOptionItems(data) {
  return Vue.axios({
    url: '/api/options/items',
    method: 'get',
    params: {fields: data}
  })
}

export function getOptionsForSelect(data) {
  return Vue.axios({
    url: '/api/options/optionsForSelect',
    method: 'get',
    params: {fields: data}
  })
}

export function getOptionItemList() {
  return Vue.axios({
    url: '/api/options/option',
    method: 'get'
  })
}

export function getOptionList(data) {
  return Vue.axios({
    url: '/api/options/list',
    method: 'get',
    params: {...data}
  })
}

export function addOrEditOption(data) {
  return Vue.axios({
    url: '/api/options/store',
    method: 'post',
    data: {...data}
  })
}

export function deleteOption(ids) {
  return Vue.axios({
    url: '/api/options/destroy',
    method: 'get',
    params: {ids}
  })
}

export function getOptionDetail(id) {
  return Vue.axios({
    url: '/api/options/detail',
    method: 'get',
    params: {id}
  })
}


export function getOptionExecutor() {
  return Vue.axios({
    url: '/api/orders/executorOption',
    method: 'get',
    params: {}
  })
}

/**
 * 招商下拉
 * @returns {*}
 */
export function getOptionCommerce() {
  return Vue.axios({
    url: '/api/orders/commerceOption',
    method: 'get',
    params: {}
  })
}

export function getOptionRadios() {
  return Vue.axios({
    url: '/api/options/radios',
    method: 'get'
  })
}
export function getOptionPlaceOrigin() {
  return Vue.axios({
    url: '/api/order/place_of_origin_option',
    method: 'get'
  })
}
